import React from 'react'
import {
   AIDrivenSmartTravelIcon,
   AIPoweredCustomerIcon,
   ContinuousSupportIcon,
   CustomHospitalitySoftwareIcon,
   CustomTailoredTravelIcons,
   OmnichannelTravelIcon,
   ScalableCloudBasedIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureTransactionsIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Hospitality Software',
      subtitle: 'Tailored Solutions for Restaurants & Hotels',
      description:
         'We build custom restaurant and hotel management applications, including POS systems, food delivery apps, and guest booking platforms, ensuring seamless service delivery.',
      icon: <CustomHospitalitySoftwareIcon />,
   },
   {
      title: 'AI-Powered Customer Insights',
      subtitle: 'Predictive Analytics and User Behavior',
      description:
         'We implement AI-driven analytics tools that analyze customer preferences, dining trends, and sales patterns, helping businesses offer personalized services.',
      icon: <AIPoweredCustomerIcon />,
   },
   {
      title: 'Secure & Compliant Transactions',
      subtitle: 'Fraud Prevention and Data Protection',
      description:
         'We create secure, scalable, and customer-focused restaurant and hospitality solutions that improve the efficiency of operations, digital adoption, and guest satisfaction.',
      icon: <SecureTransactionsIcon />,
   },
   {
      title: 'Seamless Integration with Systems',
      subtitle: 'POS, CRM, and Delivery Apps',
      description:
         'We create cloud-based hospitality platforms that are fully integrated with POS, CRM, inventory, and third-party food delivery systems for effective management.',
      icon: <SeamlessIntegrationIcon />,
   },
   {
      title: 'Scalable Cloud-Based Solutions',
      subtitle: 'Optimized for High Performance',
      description:
         'Our cloud-powered hospitality solutions support real-time data synchronization, multi-location management, and high-speed performance, enabling businesses to scale operations effortlessly.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Upgrades',
      subtitle: 'Feature Enhancements and Maintenance',
      description:
         'We provide 24/7 technical support, security updates, and feature enhancements to ensure that hospitality platforms remain competitive and future-ready.',
      icon: <ContinuousSupportIcon />,
   },
]

function TravelWhyChoose() {
   return (
      <>
         <WhyChooseOur
         classCustom='fintech_custom_why_choose'
            title={
               ' Why Choose Our Restaurant & Hospitality Software Development Services?'
            }
            desc={
               'We create safe, scalable, and customer-focused restaurant and hospitality solutions that increase operational effectiveness, digital enablement, and guest satisfaction. Here’s why businesses trust Benzatine:'
            }
            cardData={featureCards}
            // otherUi={true}
         />
      </>
   )
}

export default TravelWhyChoose
